export default __webpack_public_path__ + "static/media/c-statement-box-img-02.2e439150.png";